import { api } from '../client/axiosClient';
import { GoalDto } from '../types/dtos/common';

/**
 * Goal Service handles CRUD operations for goals.
 *
 * URL Pattern: /api/v1/goals
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * @deprecated organizationId parameters are deprecated and no longer used.
 */

const BASE_PATH = '/api/v1/goals';

/**
 * Fetch all goals for the current organization (from X-Organization-Id header).
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 */
export const fetchGoals = async (_organizationId: string): Promise<GoalDto[]> => {
  const res = await api.get<{ data: GoalDto[] }>(BASE_PATH);
  return res.data || [];
};

/**
 * Create a new goal.
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param goal - Goal data
 */
export const createGoal = async (_organizationId: string, goal: Omit<GoalDto, 'id'>): Promise<GoalDto> => {
  const res = await api.post<GoalDto>(BASE_PATH, goal);
  return res;
}; 